import utilities from "./utilities.js";

export default class FilterService {
  constructor() {
    this.state = {};

    document
      .querySelectorAll('[data-action="filter:click"]')
      .forEach((elem) => {
        elem.addEventListener("click", () =>
          this.handleChangeFilterOption(elem)
        );
      });

    document
      .querySelectorAll('[data-action="filter:change"]')
      .forEach((elem) => {
        elem.addEventListener("change", () =>
          this.handleChangeFilterOption(elem)
        );
      });

    document
      .querySelectorAll('[data-action="filter:submit"]')
      .forEach((elem) => {
        elem.addEventListener("click", () => this.submit());
      });

    this.getStateFromParams();
  }

  setState(params = {}) {
    const mergedState = Object.entries(params).reduce((acc, [key, value]) => {
      if (!acc[key]) acc[key] = [];

      if (!value) return acc;

      if (Array.isArray(value)) {
        acc[key] = value;
      } else {
        if (acc[key].includes(value)) {
          acc[key] = acc[key].filter((keyValue) => keyValue !== value);
        } else {
          acc[key].push(value);
        }
      }

      return acc;
    }, this.state);

    this.state = mergedState;
  }

  getStateFromParams() {
    const state = utilities.paramsToObject(window.location.search);
    this.setState(state);
  }

  handleChangeFilterOption(elem) {
    const { key, value, type } = elem.dataset;

    if (!key || !value) console.log("data-key or data-value not found");

    const types = String(type).split(",") || [];

    if (types.includes("toggle")) {
      if (String(this.state[key]) === value) {
        delete this.state[key];
      } else {
        this.state[key] = value;
      }
    } else {
      this.setState({ [key]: value });
    }

    for (let typeKey of types) {
      switch (typeKey) {
        case "submit":
          return this.submit();
        default:
          null;
      }
    }
  }

  submit() {
    const { origin, pathname } = window.location;
    const queryString = utilities.objectToParams(this.state);

    const url = new URL(`${origin}${pathname}?${queryString}`);

    window.location.href = url.href;
  }
}
